import PropTypes from "prop-types";
import React, { useCallback, useEffect, useRef } from "react";

// //Import Scrollbar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import withRouter from "components/Common/withRouter";
import { Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";

const SidebarContent = (props) => {
  const ref = useRef();
  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);
  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const user = JSON.parse(localStorage.getItem("user"));
  const mobileNo = user?.mobileNo;
  const targetUser = ["9428186880", "8780870844"];
  const isAdmin = authUser?.role === "ADMIN";
  const isFullAdmin = isAdmin || !targetUser.includes(mobileNo);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); // li
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove("mm-show"); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); // li
                parent5.childNodes[0].classList.remove("mm-active"); // a tag
              }
            }
          }
        }
      }
    }
  };

  const activeMenu = useCallback(() => {
    const pathName = process.env.PUBLIC_URL + props.router.location.pathname;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");

    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      const route = pathName.split("/")[1];

      // if(items[i].attributes?.otherpaths?.value.includes(route)) {
      //   console.log("ITEM ",route,items[i].attributes?.otherPaths?.value,items[i].attributes?.otherPaths?.value.includes(route))
      // }
      // console.log("PATH COMPARE ",pathName,items[i].pathname,items[i].attributes?.otherpaths?.value.includes(route))
      if (
        pathName === items[i].pathname ||
        items[i].attributes?.otherpaths?.value.includes(route)
      ) {
        //console.log("CONDITION TRUE ", items[i]);
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [props.router.location.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    new MetisMenu("#side-menu");
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    activeMenu();
  }, [activeMenu]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  return (
    <React.Fragment>
      <SimpleBar style={{ maxHeight: "100%" }} ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            {isFullAdmin && (
              <>
                <li className="menu-title">{props.t("Main")} </li>
                <li>
                  <Link to="/dashboard" className="waves-effect">
                    <i className="mdi mdi-monitor-dashboard"></i>
                    <span>{props.t("Dashboard")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/#" className="has-arrow waves-effect">
                    <i className="mdi mdi-account-group"></i>
                    <span>{props.t("User")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/UserList">{props.t("User List")}</Link>
                    </li>
                  </ul>
                </li>
              </>
            )}
            {isAdmin === true || targetUser.includes(mobileNo) ? (
              <>
                <li className="menu-title">{props.t("Main")} </li>
                <li>
                  <Link to="/#" className="has-arrow waves-effect">
                    <i className="mdi mdi-bank"></i>
                    <span>{props.t("Sangathan")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/sangathan-list">
                        {props.t("Sangathan List")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/sangathan-member-list">
                        {props.t("Sangathan Member List")}
                      </Link>
                    </li>
                  </ul>
                </li>
              </>
            ) : (
              <>
                <li>
                  <Link to="/#" className="has-arrow waves-effect">
                    <i className="mdi mdi-bank"></i>
                    <span>{props.t("Sangathan")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/sangathan-list">
                        {props.t("Sangathan List")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/sangathan-member-list">
                        {props.t("Sangathan Member List")}
                      </Link>
                    </li>
                  </ul>
                </li>
              </>
            )}
            {isFullAdmin && (
              <>
                <li>
                  <Link to="/#" className="has-arrow waves-effect">
                    <i className="mdi mdi-calendar"></i>
                    <span>{props.t("Event")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/EventList">{props.t("Event List")}</Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to="/#" className="has-arrow waves-effect">
                    <i className="mdi mdi-account-group"></i>
                    <span>{props.t("Schedules")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/Meeting">{props.t("Schedule List")}</Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to="/#" className="has-arrow waves-effect">
                    <i className="mdi mdi-map-marker"></i>
                    <span>{props.t("Location")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/LocationList">{props.t("Location List")}</Link>
                    </li>

                    {/* <li>
                  <Link to="/qualification-category-view">{props.t("Qualification Category View")}</Link>
                </li>
                <li>
                  <Link to="/qualification-category-add" otherpaths={["/qualification-category-edit","/qualification-category-add"]}>{props.t("Qualification Category Add")}</Link>
                </li> */}
                  </ul>
                </li>
                <li>
                  <Link to="/#" className="has-arrow waves-effect">
                    <i className="mdi mdi-briefcase"></i>
                    <span>{props.t("Business")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/business-approval">
                        {props.t("Business Approval")}
                      </Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to="/#" className="has-arrow waves-effect">
                    <i className="mdi mdi-compare-horizontal"></i>
                    <span>{props.t("Benefit Request")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/RequestList">{props.t("Request List")}</Link>
                    </li>

                    {/* <li>
                  <Link to="/qualification-category-view">{props.t("Qualification Category View")}</Link>
                </li>
                <li>
                  <Link to="/qualification-category-add" otherpaths={["/qualification-category-edit","/qualification-category-add"]}>{props.t("Qualification Category Add")}</Link>
                </li> */}
                  </ul>
                </li>
                <li>
                  <Link to="/#" className="has-arrow waves-effect">
                    <i className="mdi mdi-database"></i>
                    <span>{props.t("Master Data")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/categoryList">{props.t("Category")}</Link>
                    </li>
                    <li>
                      <Link to="/designationList">
                        {props.t("Designation")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/departmentList">{props.t("Department")}</Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to="/#" className="has-arrow waves-effect">
                    <i className="mdi mdi-bell"></i>
                    <span>{props.t("Notification")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to={"/Notification"}>
                        {props.t("Notification List")}
                      </Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to="/#" className="has-arrow waves-effect">
                    <i className="mdi mdi-form-select"></i>
                    <span>{props.t("Form Builder")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/forms-list">{props.t("Form List")}</Link>
                    </li>
                    <li>
                      <Link
                        to="/dynamic-form"
                        otherpaths={["/dynamic-form"]}
                      >
                        {props.t("Form Create")}
                      </Link>
                    </li>
                  </ul>
                </li>
              </>
            )}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));
